import { useState, useEffect } from "react";
import { Zap } from "lucide-react";
import { Button } from "@/components/ui/button";

const HOTMART_CHECKOUT_URL = "https://pay.hotmart.com/X103718093T?checkoutMode=10";

const FloatingCTA = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.scrollY > 600) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const handleBuyClick = () => {
    window.open(HOTMART_CHECKOUT_URL, "_blank");
  };

  if (!isVisible) return null;

  return (
    <div className="fixed bottom-4 right-4 z-50 animate-fade-in sm:bottom-6 sm:right-6">
      <div className="relative overflow-hidden rounded-2xl bg-gradient-to-r from-teal-400 via-cyan-400 to-amber-400 p-[3px] shadow-2xl">
        <div className="rounded-2xl bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 p-4 sm:p-5">
          <p className="mb-1 text-center text-sm font-bold text-white sm:text-base">
            ¿Listo para transformarte?
          </p>
          <p className="mb-3 text-center text-xs text-gray-300 sm:text-sm">
            Solo $16.99 por acceso de por vida
          </p>
          <Button
            onClick={handleBuyClick}
            className="w-full bg-gradient-to-r from-teal-500 via-cyan-500 to-amber-500 px-6 py-2 text-sm font-bold text-slate-900 shadow-lg transition-all hover:scale-105 hover:opacity-90 sm:px-8 sm:py-3 sm:text-base"
          >
            <Zap className="mr-2 h-4 w-4" />
            Obtener Acceso Ahora
          </Button>
        </div>
      </div>
    </div>
  );
};

export default FloatingCTA;
